import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';
import { replace, push } from 'react-router-redux';
import { connect } from 'react-redux';
import moment from 'moment-timezone';
import {
  Button,
  Container,
  Dropdown,
  Form,
  Grid,
  Header,
  Icon,
  Label,
  Menu,
  Segment,
} from 'semantic-ui-react';
import { withTranslation } from 'react-i18next';

import config from '../../../../config';
import fileSize from '../../../utils/fileSize';
import { fetchM } from '../../../actions/fetchM';
import { flashSuccessMessage, flashErrorMessage } from '../../../actions/flash';

import ContentPlaceholder from '../../../components/ContentPlaceholder';
import EditableBox from '../../../components/EditableBox';
import GalleryList from '../../../components/GalleryList';
import NavBar from '../../../components/NavBar';
import ProjectUnitsList from '../../../components/ProjectUnitsList';
import SpecificationTable from '../../../components/SpecificationTable';
import Timestamp from '../../../components/Timestamp';
import MarkdownText from '../../../components/MarkdownText';
import DeleteConfirm from '../../../containers/modals/DeleteConfirm';

import ViewLarge from '../../modals/ViewLarge';
import LayoutTitle from './LayoutTitle';
import { routes } from './navigations';
import { translateModels } from '../../../utils/translation';
import { isVietnamCompany, showsLayoutUnitAvailability } from '../../../utils/vietnam';
import { layoutFieldDisplay, VN_LAYOUT_FIELDS } from '../../../utils/unitLayout';
import { namespaces, TRANSLATION_FILES } from '../../../constants/translation';

moment.locale('en-gb');

class Overview extends Component {
  static propTypes = {
    id: PropTypes.string,
    unitLayoutID: PropTypes.string,
    location: PropTypes.shape({
      query: PropTypes.object,
      search: PropTypes.string,
      pathname: PropTypes.string,
    }),
    auth: PropTypes.shape({
      isBranchLeader: PropTypes.bool,
      isBranchLeaderSupervisorII: PropTypes.bool,
      isHeadquarters: PropTypes.bool,
      isSuperAdmin: PropTypes.bool,
    }),
    onCheck: PropTypes.func,
    t: PropTypes.func,
  }
  static contextTypes = {
    store: PropTypes.object,
  }
  static mapStateToProps = state => ({
    auth: state.auth,
  })
  static getPropsToState = (props) => {
    const windowWidth = window.innerWidth;
    const data = props.data || {};
    const editData = JSON.parse(JSON.stringify(data));
    const loading = props.loading;
    const menuIsTab = window.innerWidth <= 590;
    const galleryIsTab = window.innerWidth > 425;
    const isMobile = windowWidth < 768;
    return {
      data,
      editData,
      isMobile,
      loading,
      menuIsTab,
      galleryIsTab,
    };
  }
  constructor(props) {
    super(props);
    const state = Overview.getPropsToState(props);
    this.state = {
      ...state,
      collapseSegments: [{
        hideGallery: false,
        hideDocument: false,
        hideUnitAvailability: false,
      }],
      pictures: [],
      showLarge: false,
      selectedPicture: null,
      hasChanges: false,
      showDeleteConfirm: false,
      viewLargeType: 'picture',
    };
  }
  componentDidMount() {
    window.addEventListener('resize', this.handleResize, false);
  }
  componentWillReceiveProps(nextProps) {
    const state = Overview.getPropsToState(nextProps);
    this.setState({ ...state });
  }
  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize, false);
  }
  setComponentState(state = {}, callback) {
    return new Promise((res) => {
      this.setState(state, () => {
        if (callback) {
          callback();
        }
        res(state);
      });
    });
  }
  handleResize = () => {
    const state = this.state;
    const menuIsTab = window.innerWidth <= 590;
    if (menuIsTab !== this.state.menuIsTab) {
      state.menuIsTab = menuIsTab;
    }
    const galleryIsTab = window.innerWidth > 425;
    if (galleryIsTab !== this.state.galleryIsTab) {
      state.galleryIsTab = galleryIsTab;
    }
    const windowWidth = window.innerWidth;
    const isMobile = windowWidth < 768;
    if (isMobile !== this.state.isMobile) {
      state.isMobile = isMobile;
    }
    this.setState({ ...state });
  }
  handleOnCheck = (hasChanges = false) => {
    if (this.props.onCheck) {
      this.props.onCheck(hasChanges);
    }
  }
  handleCheckChanges() {
    if (!this.state.hasChanges) {
      this.setState({ hasChanges: true }, () => {
        this.handleOnCheck(true);
      });
    }
  }
  handleResetCheck() {
    if (this.state.hasChanges) {
      this.setState({ hasChanges: false }, () => {
        this.handleOnCheck(false);
      });
    }
  }
  hasAccess(check = false) {
    const user = this.props.auth;
    if (this.props.auth.isSuperAdmin || this.props.auth.isHeadquarters) {
      return true;
    }
    if (this.props.auth.isBranchLeaderSupervisorII && this.state.data.project &&
      (this.state.data.project.maOwnerCompanyBranchID === user.companyBranch.id)
    ) {
      return true;
    }
    return check;
  }
  handleCloseLarge = (e) => {
    e.preventDefault();
    this.setState({
      showLarge: false,
      selectedPicture: null,
    });
  }
  handleViewLarge = (e, data, viewLargeType = 'picture') => {
    e.preventDefault();
    this.setState({
      selectedPicture: data,
      showLarge: true,
      viewLargeType,
    });
  }
  handleMenu = (e, { value }) => {
    const { store } = this.context;
    store.dispatch(replace(value));
  }
  handleUnitClick = (e, { unit, isEditing }) => {
    const { store } = this.context;
    store.dispatch(push(`/projects/${this.props.id}/units/${unit.id}/${isEditing ? 'edit/' : ''}`));
  }
  handleSpecificationsChange = (data) => {
    const { editData } = this.state;
    editData.specifications = data;
    this.setState({ editData }, () => {
      this.handleCheckChanges();
    });
  }
  handleInputChange = (event, data) => {
    const { editData } = this.state;
    editData[data.name] = data.value;
    this.setState({ editData }, () => {
      this.handleCheckChanges();
    });
  }
  handleUpdateUnitLayout = () => {
    const { data, editData } = this.state;
    if (editData.specifications) {
      editData.specifications = editData.specifications.filter(d =>
        d.name.length > 0 && d.value.length > 0).map((d, idx) => ({
          ...d,
          position: idx + 1,
        }));
    }
    if (JSON.stringify(editData) !== JSON.stringify(data)) {
      this.updateUnitLayout(editData);
    }
    this.handleResetUnitLayout();
  }
  handleResetUnitLayout = () => {
    const editData = JSON.parse(JSON.stringify(this.state.data));
    this.setState({ editData }, () => {
      this.handleResetCheck();
    });
  }
  async updateUnitLayout(unitLayout) {
    const { store } = this.context;
    await this.setComponentState({ loading: true });
    let res;
    try {
      res = await store.dispatch(fetchM(`/projects/${this.props.id}/unit_layouts/${this.props.unitLayoutID}/`, {
        credentials: 'include',
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'X-Csrf-Token': this.props.token,
        },
        body: JSON.stringify(unitLayout),
      }));
    } catch (err) {
      Bugsnag.notifyException(err);
      if (err.res.status >= 400 && err.res.status < 500) {
        const message = await err.res.text();
        store.dispatch(flashErrorMessage({ message }));
        return;
      }
      store.dispatch(flashErrorMessage(err));
    }
    const data = await res.json();
    await this.setComponentState({ loading: false }, () => {
      this.handleResetCheck();
    });
    store.dispatch(push(`/projects/${this.props.id}/layouts/${this.props.unitLayoutID}/`));
    store.dispatch(flashSuccessMessage({ header: 'Update Success', message: `${data.name} successfully updated` }));
  }
  async deleteUnitLayout() {
    const { store } = this.context;
    await this.setState({ loading: true });
    try {
      await store.dispatch(fetchM(`/projects/${this.props.id}/unit_layouts/${this.props.unitLayoutID}/`, {
        credentials: 'include',
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
          'X-Csrf-Token': this.props.token,
        },
      }));
    } catch (err) {
      await this.setState({ loading: false });
      Bugsnag.notifyException(err);
      if (err.res.status >= 400 && err.res.status < 500) {
        const message = await err.res.text();
        store.dispatch(flashErrorMessage({ message }));
        return;
      }
      store.dispatch(flashErrorMessage(err));
    }
    await this.setState({ loading: false });
    store.dispatch(replace(`/projects/${this.props.id}/`));
    store.dispatch(flashSuccessMessage({ header: 'Delete Success', message: 'Unit layout successfully deleted' }));
  }
  handleGetPicture = (pictures) => {
    this.setState({ pictures });
  }
  handleSlidePicture = (e, direction = 'right') => {
    const { pictures, selectedPicture } = this.state;
    const index = pictures.indexOf(selectedPicture);
    const nextIndex = direction === 'left' ? index - 1 : index + 1;
    this.setState({
      selectedPicture: pictures[nextIndex],
    });
  }
  checkDisabled(direction = 'right') {
    const { pictures, selectedPicture } = this.state;
    if (selectedPicture) {
      const index = pictures.indexOf(selectedPicture);
      if (direction === 'left') {
        return index - 1 >= 0;
      }
      return index + 1 < pictures.length;
    }
    return false;
  }
  handleCancelDelete = (e) => {
    e.preventDefault();
    this.setState({
      showDeleteConfirm: false,
    });
  }
  handleConfirmDelete = (e) => {
    e.preventDefault();
    this.setState({
      showDeleteConfirm: false,
    }, () => {
      this.deleteUnitLayout();
    });
  }
  handleDelete = (e) => {
    e.preventDefault();
    this.setState({
      showDeleteConfirm: true,
    });
  }
  handleOnCollapseSegment = (e, { name, value }) => {
    const { collapseSegments } = this.state;
    e.preventDefault();
    collapseSegments[name] = !value;
    this.setState({ collapseSegments });
  }
  canDelete = () => {
    const { data } = this.state;
    if (data.summary && !data.summary.totalUnits) {
      return true;
    }
    return false;
  }
  getProjectUnitLayoutPictures = () => {
    const { data } = this.state;
    let newPictures = [];
    if (data.pictures != null && data.pictures.length > 0) {
      newPictures = data.pictures.map((p) => {
        const newP = { ...p };
        if (p.unitLayouts != null && p.unitLayouts.length > 0) {
          if (p.unitLayouts[0].type !== '') newP.type = p.unitLayouts[0].type;
        }
        return newP;
      });
    }
    if (data.medias != null && data.medias.length > 0) {
      newPictures = newPictures.concat(data.medias);
    }
    return newPictures;
  }
  render() {
    const { t } = this.props;
    const { pathname } = this.props.location;
    const { store } = this.context;
    const { data, editData, isMobile } = this.state;
    const { hideGallery, hideDocument, hideUnitAvailability } = this.state.collapseSegments;
    const links = routes(this.props.id, this.props.unitLayoutID, this.hasAccess());
    const isVietnam = isVietnamCompany(this.props.auth);
    return (
      <Container>
        <DeleteConfirm
          open={this.state.showDeleteConfirm}
          onClose={this.handleCancelDelete}
          onConfirm={this.handleConfirmDelete}
          name={data.name || 'Layout'}
        />
        <NavBar
          header={links.length > 1 ? null : t('Overview')}
          links={
            links.length > 1 && (this.state.menuIsTab ?
              <Dropdown
                item
                selectOnBlur={false}
                options={links}
                onChange={this.handleMenu}
                value={pathname}
              />
            : links.map((link, key) => (
              <Menu.Item
                key={key}
                name={t(link.text)}
                content={t(link.text)}
                active={pathname === link.value}
                onClick={() => store.dispatch(replace(link.value))}
              />
            )))
          }
          rightNav={this.hasAccess() ?
            <Menu.Item fitted>
              <div>
                {
                  this.hasAccess() && this.canDelete() && (
                    <Button
                      color="red"
                      disabled={this.state.loading}
                      icon
                      title="Delete"
                      onClick={this.handleDelete}
                    >
                      <Icon name="trash" />
                    </Button>
                  )
                }
                {
                  this.hasAccess() && (
                    <Button
                      as={Link}
                      primary
                      content={t('Edit', { ns: TRANSLATION_FILES.translation })}
                      disabled={this.state.loading}
                      to={`/projects/${this.props.id}/layouts/${this.props.unitLayoutID}/edit/`}
                    />
                  )
                }
              </div>
            </Menu.Item> : null
          }
        />
        <Grid verticalAlign="top" columns="equal">
          <ViewLarge
            open={this.state.showLarge}
            onClose={this.handleCloseLarge}
            picture={this.state.selectedPicture}
            onSlide={this.handleSlidePicture}
            disabledLeft={!this.checkDisabled('left')}
            disabledRight={!this.checkDisabled('right')}
            slideshow
            type={this.state.viewLargeType}
          />
        </Grid>
        <LayoutTitle data={data} />
        {/* CPI-1208: what a Vietnamese layout records, read-only. It is edited on the layout form
            (Projects -> Unit Layouts -> Edit); an empty field shows a dash, the same empty state
            the buyer site uses. Nothing renders here for any other country. */}
        {isVietnam && (
          <Grid>
            <Grid.Row style={{ marginTop: '1em' }}>
              <Grid.Column width={16} style={isMobile ? { padding: '0' } : {}}>
                <Segment>
                  <Grid columns="equal" doubling stackable>
                    {VN_LAYOUT_FIELDS.map(field => (
                      <Grid.Column key={field} textAlign="center">
                        <Header size="tiny">
                          {translateModels(t, field, 'projectUnitLayout')}
                          <Header.Subheader>
                            {layoutFieldDisplay(data[field])}
                          </Header.Subheader>
                        </Header>
                      </Grid.Column>
                    ))}
                  </Grid>
                </Segment>
              </Grid.Column>
            </Grid.Row>
          </Grid>
        )}
        <Grid>
          <Grid.Row style={{ marginTop: '1em' }}>
            <Grid.Column width={16} style={isMobile ? { padding: '0' } : {}}>
              {
                this.hasAccess(data.overview) ?
                  <Grid.Row verticalAlign="middle">
                    <Grid.Column>
                      <EditableBox
                        newHeader={translateModels(t, 'overview', 'projectUnitLayout').toUpperCase()}
                        isCollapsible
                        hideBorder
                        editable={this.hasAccess()}
                        loading={this.state.loading}
                        onClick={this.handleUpdateUnitLayout}
                        onCancel={this.handleResetUnitLayout}
                        content={({ isEditing, onConfirm }) => (
                          isEditing ? (
                            <Form onSubmit={onConfirm}>
                              <Form.TextArea
                                placeholder={translateModels(t, 'overview', 'projectUnitLayout')}
                                name="overview"
                                value={editData.overview}
                                onChange={this.handleInputChange}
                              />
                            </Form>
                          ) : (
                            <ContentPlaceholder
                              paragraphs
                              loading={this.state.loading}
                            >
                              {
                                data.overview ? <MarkdownText content={data.overview} /> :
                                <Segment textAlign="center">
                                  <p>{t('Description not set')}.</p>
                                  <Button
                                    as={Link}
                                    primary compact
                                    disabled={this.state.loading}
                                    to={`/projects/${this.props.id}/layouts/${this.props.unitLayoutID}/edit/#info`}
                                  >
                                    {t('Click here to add')}
                                  </Button>
                                </Segment>
                              }
                            </ContentPlaceholder>
                          )
                        )}
                      />
                    </Grid.Column>
                  </Grid.Row>
                : null
              }
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column width={16} style={isMobile ? { padding: '0' } : {}}>
              {
                this.hasAccess(data.specifications && data.specifications.length > 0) ?
                  <Grid.Row>
                    <Grid.Column>
                      <SpecificationTable
                        newHeader={t('Layout Specification').toUpperCase()}
                        isCollapsible
                        type="unit_layouts"
                        data={editData.specifications}
                        editable={this.hasAccess()}
                        loading={this.state.loading}
                        onChange={this.handleSpecificationsChange}
                        onClick={this.handleUpdateUnitLayout}
                        onCancel={this.handleResetUnitLayout}
                        notFoundNode={<p>{t('No information set')}.</p>}
                        onAdd={() => store.dispatch(push(`/projects/${this.props.id}/layouts/${this.props.unitLayoutID}/edit/#specifications`))}
                      />
                    </Grid.Column>
                  </Grid.Row>
                : null
              }
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column width={16} style={isMobile ? { padding: '0' } : {}}>
              {
                this.hasAccess(data.pictures && data.pictures.length > 0) || data.virtualTourURL !== '' ?
                  <Header
                    className="new_title"
                    as="h5"
                    textAlign="center"
                    attached="top"
                  >
                    <Grid>
                      <Grid.Row>
                        <Grid.Column width={16} textAlign="center">
                          {t('Gallery').toUpperCase()}
                        </Grid.Column>
                        <Label
                          as="button"
                          attached="top right"
                          icon={hideGallery ? 'angle up' : 'angle down'}
                          className="collapse-button"
                          style={{
                            position: 'absolute',
                            right: '0',
                            top: '3px',
                            marginRight: '0',
                            marginTop: '0.5em',
                          }}
                          name="hideGallery"
                          value={hideGallery}
                          onClick={this.handleOnCollapseSegment}
                          disabled={this.state.loading}
                        />
                      </Grid.Row>
                    </Grid>
                  </Header> : null
              }
              {
                (this.hasAccess(data.pictures && data.pictures.length > 0) || data.virtualTourURL !== '') && !hideGallery ?
                  <Segment attached>
                    {
                      data.virtualTourURL !== '' ? (
                        <Grid.Row>
                          <Grid.Column style={{ textAlign: 'right', paddingBottom: '1em' }}>
                            <Button
                              as="a"
                              color="teal"
                              icon="street view"
                              content="Virtual Tour"
                              disabled={this.state.loading}
                              href={data.virtualTourURL}
                              target="_blank"
                              rel="noopener noreferrer"
                            />
                          </Grid.Column>
                        </Grid.Row>
                      ) : null
                    }
                    {
                      this.hasAccess((data.pictures && data.pictures.length > 0) || (data.medias && data.medias.length > 0)) ? (
                        <Grid.Row>
                          <Grid.Column>
                            <GalleryList
                              editable={this.hasAccess()}
                              pictures={this.getProjectUnitLayoutPictures()}
                              projectID={this.props.id}
                              unitLayoutID={this.props.unitLayoutID}
                              loading={this.state.loading}
                              excludeType={['site_plan', 'map']}
                              tabular={this.state.galleryIsTab}
                              onViewLarge={this.handleViewLarge}
                              onChange={this.handleGetPicture}
                              addPath={`/projects/${this.props.id}/layouts/${this.props.unitLayoutID}/pictures/`}
                              addVideoPath={`/projects/${this.props.id}/layouts/${this.props.unitLayoutID}/videos/`}
                            />
                          </Grid.Column>
                        </Grid.Row>
                      ) : null
                    }
                  </Segment>
                : null
              }
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column width={16} style={isMobile ? { padding: '0' } : {}}>
              {
                this.hasAccess(data.documents && data.documents.length > 0) ?
                  <Header
                    className="new_title"
                    as="h5"
                    textAlign="center"
                    attached="top"
                  >
                    <Grid>
                      <Grid.Row>
                        <Grid.Column width={16} textAlign="center">
                          {t('Documents').toUpperCase()}
                        </Grid.Column>
                        <Label
                          as="button"
                          attached="top right"
                          icon={hideDocument ? 'angle up' : 'angle down'}
                          className="collapse-button"
                          style={{
                            position: 'absolute',
                            right: '0',
                            top: '3px',
                            marginRight: '0',
                            marginTop: '0.5em',
                          }}
                          name="hideDocument"
                          value={hideDocument}
                          onClick={this.handleOnCollapseSegment}
                          disabled={this.state.loading}
                        />
                      </Grid.Row>
                    </Grid>
                  </Header> : null
              }
              {
                this.hasAccess(data.documents && data.documents.length > 0) && !hideDocument ?
                  <Segment attached>
                    <Grid.Row>
                      <Grid.Column>
                        <Segment.Group>
                          {
                            data.documents && data.documents.length > 0 ?
                            data.documents.map((file, idx) => (
                              <Segment key={idx}>
                                <Grid
                                  columns="equal"
                                  verticalAlign="middle"
                                  as="a"
                                  href={`${config.get('bookApiURL')}/documents/${file.id}/view/${encodeURIComponent(file.name)}.pdf`}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                >
                                  <Grid.Column>
                                    <Icon name="file pdf outline" />
                                    {file.name}
                                    <span className="mobile-hide"> ({fileSize(file.size)})</span>
                                    <small className="large-hide small-hide tablet-hide"><br />{fileSize(file.size)}</small>
                                  </Grid.Column>
                                  <Grid.Column textAlign="right">
                                    <small><Timestamp format="DD/MM/YY hh:mm a" timestamp={file.createdAt} /></small>
                                  </Grid.Column>
                                </Grid>
                              </Segment>
                            )) : (
                              <Segment textAlign="center">
                                <p>{t('No documents found')}.</p>
                                <Button
                                  as={Link}
                                  primary compact
                                  disabled={this.state.loading}
                                  to={`/projects/${this.props.id}/layouts/${this.props.unitLayoutID}/documents/`}
                                >
                                  {t('Click here to add')}
                                </Button>
                              </Segment>
                            )
                          }
                        </Segment.Group>
                      </Grid.Column>
                    </Grid.Row>
                  </Segment>
                : null
              }
            </Grid.Column>
          </Grid.Row>
          {
            showsLayoutUnitAvailability(this.props.auth) &&
            <Grid.Row>
              <Grid.Column width={16} style={isMobile ? { padding: '0' } : {}}>
                <Header
                  className="new_title"
                  as="h5"
                  textAlign="center"
                  attached="top"
                >
                  <Grid>
                    <Grid.Row>
                      <Grid.Column width={16} textAlign="center">
                        {(t('Unit Availability')).toUpperCase()}
                      </Grid.Column>
                      <Label
                        as="button"
                        attached="top right"
                        icon={hideUnitAvailability ? 'angle up' : 'angle down'}
                        className="collapse-button"
                        style={{
                          position: 'absolute',
                          right: '0',
                          top: '3px',
                          marginRight: '0',
                          marginTop: '0.5em',
                        }}
                        name="hideUnitAvailability"
                        value={hideUnitAvailability}
                        onClick={this.handleOnCollapseSegment}
                        disabled={this.state.loading}
                      />
                    </Grid.Row>
                  </Grid>
                </Header>
                {
                  !hideUnitAvailability ? (
                    <Segment attached>
                      <Grid.Row>
                        <Grid.Column>
                          <ProjectUnitsList
                            toggleable
                            loading={this.state.loading}
                            projectID={this.props.id}
                            project={data.project}
                            unitLayoutID={this.props.unitLayoutID}
                            unitOnClick={this.handleUnitClick}
                            hideNew="true"
                            addPath={`/projects/${this.props.id}/units/new/?unitLayoutID=${this.props.unitLayoutID}`}
                            notFoundNode={(
                              <span>
                                <p>No units found.</p>
                                {
                                  this.hasAccess() &&
                                  <Button
                                    as={Link}
                                    primary compact
                                    disabled={this.state.loading}
                                    to={`/projects/${this.props.id}/units/new/?unitLayoutID=${this.props.unitLayoutID}`}
                                  >
                                    Click here to add
                                  </Button>
                                }
                              </span>
                            )}
                          />
                        </Grid.Column>
                      </Grid.Row>
                    </Segment>
                  ) : null
                }
              </Grid.Column>
            </Grid.Row>
          }
        </Grid>
      </Container>
    );
  }
}


export default withTranslation([
  ...namespaces,
  TRANSLATION_FILES.models.projectUnitLayout,
])(connect(Overview.mapStateToProps)(Overview));



// WEBPACK FOOTER //
// ./src/containers/Project/UnitLayout/Overview.jsx